/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFormRow, EuiRadio, EuiFlexGroup, EuiFlexItem, EuiToolTip } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { AccessControl } from '@modules/network-security-lib/types'

type Props = {
  value: AccessControl
  onChange: (value: AccessControl) => void
}

const AccessControlField: React.FunctionComponent<Props> = ({ value, onChange }) => (
  <EuiFormRow
    label={<FormattedMessage id='accessControlField.label' defaultMessage='Access control' />}
  >
    <EuiFlexGroup gutterSize='l'>
      <EuiFlexItem grow={false}>
        <EuiRadio
          id='access-control-ingress'
          label={<FormattedMessage id='accessControlField.ingressLabel' defaultMessage='Ingress' />}
          checked={value === 'ingress'}
          onChange={() => onChange('ingress')}
          name='access-control'
        />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiToolTip
          content={
            <FormattedMessage
              id='accessControlField.egressLabel.comingSoon'
              defaultMessage='Coming soon'
            />
          }
        >
          <EuiRadio
            id='access-control-egress'
            disabled={true}
            label={<FormattedMessage id='accessControlField.egressLabel' defaultMessage='Egress' />}
            checked={value === 'egress'}
            onChange={() => onChange('egress')}
            name='access-control'
          />
        </EuiToolTip>
      </EuiFlexItem>
    </EuiFlexGroup>
  </EuiFormRow>
)

export default AccessControlField
